
<script>
import {reconciledTransaction as columns} from '../../tables'

export default {
  name: "reconciled-transaction-list",
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  computed: {
    uri() {
      return (this.path !== '') ? this.path : this.routeUri('hyperion.transaction.reconciled')
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD HH:mm'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD HH:mm'))
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
    exportUri() {
      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime()
      })

      return this.routeUri('hyperion.transaction.reconciled.export') + '?' + this.$qs.stringify(params)
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      items: {},
      loading: false,
      expand: false,
      loadingDownload: false,
      modal: {
        visible: false,
        item: {}
      },
      filters: {
        page: 1,
        per_page: 10,
        date: [],
        products: []
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleAutocomplete(v, iteratee) {
      if (v.length === 0) {
        this.filters[iteratee] = []
      } else {
        this.filters[iteratee] = _.map(v, (o) => o.id)
      }
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        page: 1,
        per_page: 10,
        q: '',
        products: [],
        service: [],
        status: [],
        date: []
      }
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    handleDownload(e) {
      // window.open(this.exportUri, '_blank')
      this.loadingDownload = true

      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime(),
        format: e.key
      })

      this.$http.get(this.routeUri('hyperion.transaction.reconciled.export') + '?' + this.$qs.stringify(params))
      .then(() => this.handleSuccessResponse())
      .catch((error) => this.handleResponseError(error))
      .finally(() => this.loadingDownload = false)
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Proccess!',
        description: 'Data has been processed!'
      })
    },
    handleResponseError(data) {
      this.$notification.error({
        message: "Failed to export data",
        description: data.message
      })
    }
  }
}
</script>

<template>
  <a-card size="small" type="inner" :title="items.total > 0 ? 'Reconciled Payment Transaction '+items.total +' record(s)' : 'Reconciled Payment Transaction'">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">
        <a-col :span="6">
          <a-input placeholder="Keyword.." v-model="filters.q">
            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-range-picker :show-time="{ format: 'HH:mm' }" :ranges="dateRanges" format="YYYY-MM-DD HH:mm" v-model="filteredRanges" style="width: 100%"/>
        </a-col>

        <a-col :span="6">
          <product-autocomplete style="width: 100%" @change="(item) => handleAutocomplete(item, 'products') "/>
        </a-col>

        <a-col :span="6">
          <client-autocomplete style="width: 100%" @change="(item) => handleAutocomplete(item, 'clients') "/>
        </a-col>

        <a-col :span="6">
          <biller-autocomplete style="width: 100%" @change="(item) => handleAutocomplete(item, 'billers') "/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>
          <a-dropdown>
            <a-menu slot="overlay" @click="handleDownload">
              <a-menu-item key="xlsx">
                <a-icon type="file-excel" theme="twoTone" two-tone-color="#52c41a"/> XLSX
              </a-menu-item>
              <a-menu-item key="csv">
                <a-icon type="file-text" theme="twoTone"/> CSV
              </a-menu-item>
            </a-menu>
            <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" :style="{ display: expand ? 'inline-block' : 'none'}" :loading="loadingDownload"/>
          </a-dropdown>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="transaction_ref_id"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged">
        <h5 slot="reconcileTime" slot-scope="time" class="text-center">
          {{ moment(time).format('DD/MM/YYYY HH:mm:ss') }}
        </h5>

        <h5 slot="transactionTime" slot-scope="time" class="text-center">
          {{ moment(time).format('DD/MM/YYYY HH:mm:ss') }}
        </h5>

        <div slot="transaction" slot-scope="record">
          <h4>{{ record.subscriber_id }} // <small>{{ record.product.name }}</small>
            <a-button size="small" type="link" @click="copy(record.subscriber_id)" icon="copy"/>
          </h4>

          <h4>
            <span style="color: #374e9e"><a-icon type="solution" /> {{ record.client.name }}</span>
            &nbsp; --- &nbsp;
            <span style="color: #9a1e8d"><a-icon type="deployment-unit"/> {{ record.biller.name }}</span>
          </h4>

          <small v-if="record.additional_transaction !== null">
            <a-icon type="scan"/>&nbsp;<code>{{ record.additional_transaction.customer_account_number ? record.additional_transaction.customer_account_number : ''}}</code>&emsp;
          </small>

          <small v-if="record.additional_transaction !== null">
            <a-icon type="shop"/>&nbsp;<code>{{ record.additional_transaction.merchant ? record.additional_transaction.merchant : ''}}</code>
            <br>
          </small>

          <small v-if="record.ref_num !== null">
            # <code>{{ record.ref_num }}</code>
            <a-button size="small" type="link" @click="copy(record.ref_num)" icon="copy"/>
          </small>

          <small>
            UUID: <code>{{ record.transaction_ref_id }}</code>
            <a-button size="small" type="link" @click="copy(record.transaction_ref_id)" icon="copy"/>
          </small>

          <template v-if="! isEmpty(record.client_trx_id)">
            <br>
            <small><a-icon type="pushpin" /> <code>{{ record.client_trx_id }}</code></small>
          </template>
        </div>

        <div slot="subscriber" slot-scope="record">
          <div>
            <h4>{{ record.subscriber_name }}</h4>
            <h5>
              - <code>Subscriber ID: {{ record.subscriber_id }}</code><br>
              - <code>Alternate ID: {{ record.alternate_id }}</code><br>
              - <code>SN: {{ record.ref_num }}</code><br>
            </h5>
          </div>
        </div>

        <div slot="client" slot-scope="record">
          <h4 :style="{ color: record.price >= 0 ? '#237804' : '#a8071a'}">{{ currency(record.price) }}</h4>
          <h5>
            <span :style="{ color: '#2f2f2f'}">{{ currency(record.client_admin_fee) }}</span><br>
            <span :style="{ color: '#2f2f2f'}">{{ currency(record.client_share_fee) }}</span><br>
          </h5>
        </div>

        <div slot="biller" slot-scope="record" :style="{ color: '#2f2f2f'}">
          <h4 :style="{ color: record.biller_price >= 0 ? '#237804' : '#a8071a'}">{{ currency(record.biller_price) }}</h4>
          <h5>
            <span :style="{ color: '#2f2f2f'}">{{ currency(record.biller_admin_fee) }}</span><br>
            <span :style="{ color: '#2f2f2f'}">{{ currency(record.biller_share_fee) }}</span><br>
          </h5>
        </div>

        <h4 slot="profit" slot-scope="record" :style="{ color: record.profit >= 0 ? '#237804' : '#a8071a'}">
          {{ currency(record.profit) }}
        </h4>
      </a-table>
    </a-skeleton>
  </a-card>
</template>
